<template>
	<nav class="breadcrumbs" />
</template>

<script setup>
defineProps({
	breadcrumbs: { type: Array, default: () => [] },
});
</script>

<style lang="scss" scoped>
.breadcrumbs {
	background: var(--cta-color);
	padding: 0;

	&.no-slider {
		margin-top: 93px;
	}
}

@media (max-width: 600px) {
	.breadcrumbs {
		&.no-slider {
			margin-top: 83px;
		}
	}
}
</style>
